import { Component } from '@angular/core';

@Component({
    selector: 'ddv-global-icon',
    templateUrl: './global-icon.component.html',
    styleUrls: ['./global-icon.component.scss'],
    standalone: false,
})
export class GlobalIconComponent {}
